<template>
  <div class="divider-block" :style="containerStyle">
    <div :style="dividerStyle" class="divider-line"></div>
  </div>
</template>

<script>
export default {
  name: 'DividerBlock',
  props: {
    color: {
      type: String,
      default: '#e2e8f0'
    },
    style: {
      type: String,
      default: 'solid'
    },
    width: {
      type: String,
      default: '100%'
    },
    thickness: {
      type: String,
      default: '1px'
    },
    align: {
      type: String,
      default: 'center'
    },
    margin: {
      type: String,
      default: '20px 0'
    },
    padding: {
      type: String,
      default: '0'
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    borderRadius: {
      type: String,
      default: '0px'
    },
    opacity: {
      type: String,
      default: '1'
    }
  },
  computed: {
    containerStyle() {
      return {
        width: '100%',
        textAlign: this.align,
        margin: this.margin,
        padding: this.padding,
        backgroundColor: this.backgroundColor,
        boxSizing: 'border-box'
      }
    },
    dividerStyle() {
      const styles = {
        border: 'none',
        backgroundColor: this.style === 'solid' ? this.color : 'transparent',
        height: this.thickness,
        width: this.width,
        borderRadius: this.borderRadius,
        opacity: this.opacity,
        margin: '0 auto',
        display: 'block'
      }

      // Estilos específicos según el tipo
      switch (this.style) {
        case 'dotted':
          styles.borderTop = `${this.thickness} dotted ${this.color}`
          styles.backgroundColor = 'transparent'
          styles.height = '0'
          break
        case 'dashed':
          styles.borderTop = `${this.thickness} dashed ${this.color}`
          styles.backgroundColor = 'transparent'
          styles.height = '0'
          break
        case 'double':
          styles.borderTop = `${this.thickness} double ${this.color}`
          styles.backgroundColor = 'transparent'
          styles.height = '0'
          break
        case 'groove':
          styles.borderTop = `${this.thickness} groove ${this.color}`
          styles.backgroundColor = 'transparent'
          styles.height = '0'
          break
        case 'ridge':
          styles.borderTop = `${this.thickness} ridge ${this.color}`
          styles.backgroundColor = 'transparent'
          styles.height = '0'
          break
        case 'gradient':
          styles.background = `linear-gradient(to right, transparent, ${this.color}, transparent)`
          styles.height = this.thickness
          break
        case 'solid':
        default:
          // Ya configurado arriba
          break
      }

      return styles
    }
  }
}
</script>

<style scoped>
.divider-block {
  width: 100%;
}

.divider-line {
  transition: all 0.3s ease;
}

.divider-block:hover .divider-line {
  transform: scaleY(1.2);
}

/* Estilos especiales para diferentes tipos */
.divider-line.pattern-dots {
  background-image: radial-gradient(circle, currentColor 1px, transparent 1px);
  background-size: 8px 8px;
  background-repeat: repeat-x;
  background-position: center;
}

.divider-line.pattern-waves {
  background-image: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 4px,
    currentColor 4px,
    currentColor 8px
  );
}
</style> 